import { useContext } from 'react';
import { InnovationPrioritiesContext } from '../components/context/innovation-priorities-context';
export const useInnovationPriorities = () => useContext(InnovationPrioritiesContext);